import { render, staticRenderFns } from "./addPrize.vue?vue&type=template&id=bcd41272&scoped=true&"
import script from "./addPrize.vue?vue&type=script&lang=ts&"
export * from "./addPrize.vue?vue&type=script&lang=ts&"
import style0 from "./addPrize.vue?vue&type=style&index=0&id=bcd41272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd41272",
  null
  
)

export default component.exports